import http from '@/utils/http/index';

/**
 * shopline提交
 */
export function postMyshopline(params) {
  return http.post('/shop/oauth/shopline/auth', params);
}
